import { useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import style from "./e-VisaModa.module.css";

export default function E_VisaModal({ URL, close }) {
  // Redirect function
  function redirectToUrl(URL) {
    const newTab = window.open(URL, "_blank");

    if (!newTab || newTab.closed || typeof newTab.closed === "undefined") {
      // Fallback if popup blocked
      window.location.href = URL;
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      // Close modal first
      close();

      // Delay slightly to ensure modal unmount animation/transition
      setTimeout(() => {
        redirectToUrl(URL);
      }, 200); // 200ms delay, adjust if needed
    }, 4000); // initial wait before auto-redirect

    return () => clearTimeout(timer);
  }, [URL]);

  return (
    <div className={style.container}>
      <header className={style.evisa_header}>
        <h4>Start Visa Application</h4>
        <h2
          onClick={() => {
            close();
          }}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <IoMdClose />
        </h2>
      </header>

      <div className={style.main_container}>
        <div className={style.top_section}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <img
              src={
                process.env.PUBLIC_URL + "/assets/images/e-visa-modal-new-5.png"
              }
              style={{
                width: "14rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              alt="share_image"
            />
          </div>
          <div className={style.top_section_des}>
            <p>
              You are now leaving VisaLancer App and being redirected to the
              Travel e-Visa App
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
